import React, { useEffect, useState } from "react";
import styles from "./LicitacionesPublicas.module.scss";
import { connect } from "react-redux";
import {
  clearProjects,
  filterPublicProjects,
} from "../../store/actions";
import FilterPublicProject from "../../components/Filters/FilterPublicProjects/FilterPublicProject.tsx";
import EmptyState from "../../components/UI/EmptyState/EmptyState";
import BotoneraModern from "../../components/Botonera/BotoneraModern.tsx";
import useSuscriptionModalTimeout from "../../hooks/useSuscriptionModalTimeout";
import Pagination from "../../hooks/pagination";
import { ReactComponent as NoResultsIcon } from "../../assets/svg/NoResultsMagnifier.svg";
import styled from "styled-components";
import Breadcrumbs from "../../components/UI/Breadcrumbs/Breadcrumbs.tsx";
import { fireAnalytics } from "../../utils/firebase";
import RegisteredUserProfileLoader from "../../components/RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";
import { getSessionId, getDeviceCategory, getPreviousPage, getDashboardSource } from "../../utils/analyticsHelpers.ts";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-right: 2%;
  padding-left: 2%;
  max-width: 150rem;
        margin: auto;

  @media (max-width: 1200px) {
    padding-right: 2%;
    padding-left: 2%;
    }

  @media (max-width: 768px) {
    padding-right: 0;
    padding-left: 0;
  }
`;


const LicitacionesPublicas = ({
  allProjects,
  loading,
  userData,
  initialProjectType = "A licitar",
  itemCount,
  take,
}) => {
  const pageNumberLimit = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);
  const [mobileStylesFromParent, setMobileStylesFromParent] = useState(false);
  const [ocultarEnMobile, setOcultarEnMobile] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [isAdjudicated, setIsAdjudicated] = useState(false);
  const paginationAttributes = {
    currentPage,
    maxPageLimit,
    minPageLimit,
    response: allProjects,
  };
  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const onPrevClick = () => {
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageLimit(maxPageLimit - pageNumberLimit);
      setMinPageLimit(minPageLimit - pageNumberLimit);
    }
    setCurrentPage((prev) => prev - 1);
  };

  const onNextClick = () => {
    if (currentPage + 1 > maxPageLimit) {
      setMaxPageLimit(maxPageLimit + pageNumberLimit);
      setMinPageLimit(minPageLimit + pageNumberLimit);
    }
    setCurrentPage((prev) => prev + 1);
  };

  const totalPage = Math.ceil((itemCount ?? allProjects?.itemCount ?? 0) / (take || 9)) || 1;
  const onPrevWindow = () => {
    const newMin = Math.max(0, minPageLimit - pageNumberLimit);
    const newMax = minPageLimit;
    const targetPage = newMin + 1;
    setCurrentPage(targetPage);
    setMaxPageLimit(newMax);
    setMinPageLimit(newMin);
  };
  const onNextWindow = () => {
    const targetPage = Math.min(totalPage, maxPageLimit + 1);
    setCurrentPage(targetPage);
    const newMin = maxPageLimit;
    const newMax = Math.min(totalPage, maxPageLimit + pageNumberLimit);
    setMaxPageLimit(newMax);
    setMinPageLimit(newMin);
  };

  useSuscriptionModalTimeout();

  const handleResize = () => {
    const windowWidth = window.innerWidth;
    setOcultarEnMobile(windowWidth < 900);
    setMobileStylesFromParent(windowWidth < 900);
  };

  useEffect(() => {
    handleResize();
    
    
    // Nuevo evento estandarizado
    fireAnalytics("page_obras_publicas_view", {
      edify_user_id: userData.id,
      session_id: getSessionId(),
      source: getDashboardSource(),
      previous_page: getPreviousPage(),
      device_category: getDeviceCategory(),
      category: "navigation",
      action: "page_view",
      page_name: "obras_publicas"
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <Container>
      {ocultarEnMobile &&
        <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} />}
      <div className={styles.projectsContainer}>
        <div className={styles.breadcrumbContainer}>
          <Breadcrumbs />
        </div>
        <FilterPublicProject
          setIsFiltered={setIsFiltered}
          setIsAdjudicated={setIsAdjudicated}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          initialProjectType={initialProjectType}
        />
        <div className={styles.AllProjects} id="allProjects">
          {loading ? (
            <div className={styles.loadingContainer}>
            <RegisteredUserProfileLoader/>
            </div>
          ) : (
            <div className={styles.generalContainer}>
              {allProjects && allProjects.length === 0 ? (
                <div className={styles.emptyState}>
                  <EmptyState title="No hay resultados para su búsqueda." icon={<NoResultsIcon width={80} height={80}/>} />
                </div>
              ) : null}
              <Pagination
                {...paginationAttributes}
                onPrevClick={onPrevClick}
                onNextClick={onNextClick}
                onPageChange={onPageChange}
                onPrevWindow={onPrevWindow}
                onNextWindow={onNextWindow}
                isPublicProject={true}
              />
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    allProjects: state.dashboard.viewProjects,
    isFilter: state.dashboard.isFilter,
    page: state.dashboard.page,
    searchParams: state.dashboard.searchParams,
    loading: state.dashboard.loading,
    userData: state.general.userData,
    itemCount: state.dashboard.itemCount,
    take: state.dashboard.take,
  };
};

export default connect(mapStateToProps, {
  clearProjects,
  filterPublicProjects,
})(LicitacionesPublicas);
